import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from '@kambria/kambria-lego';
import Modal from 'react-bootstrap4-modal';
import { SelectField, TextField } from 'views/components/core/ReduxForm';
import LoadingButton from 'views/components/LoadingButton';

import { transferKAT, transferKYTE } from 'redux/actions/blockchain.action';
import { depositKWallet } from 'redux/actions/kWallet.action';
import * as types from 'redux/actions/actionTypes';
import enums from 'helpers/const';

const FORM_NAME = 'depositKWallet';
const { DEPOSIT_TYPE, ERROR_STALE_TRANSACTION_ID } = enums;
const { KAT, KYTE } = DEPOSIT_TYPE;
const TYPE_DEPOSIT = [
  { label: KAT, value: KAT },
  { label: KYTE, value: KYTE },
];
const ERROR_TRANSACTION = 'Transaction Error';

const required = (value) => (value ? undefined : 'Required');

class DepositModal extends React.Component {
  state = { transferErrorMessage: '' };

  componentDidMount() {
    window.addEventListener('beforeunload', (e) => this.keepOnPage(e, this.props));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.keepOnPage);
  }

  keepOnPage(e, props) {
    const { status, kWallet } = props;
    const { sendingDeposit } = kWallet;
    if (sendingDeposit || [1, 2].includes(status)) {
      e.preventDefault();
      const message =
        'Warning!' +
        '\n\nNavigating away from this page will DELETE your ' +
        "Transaction Deposit if system haven't already saved it.";
      (e || window.event).returnValue = message;
      return message;
    }
    return;
  }

  submitRequest = async (value) => {
    const { depositKWallet: deposit, onDeposit } = this.props;
    const { type, amount, address, txIdInput } = value;
    const errors = {};
    const validAmount = Number(amount) > 0;
    if (!validAmount) errors.amount = 'Invalid Number';
    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    }
    const txId = txIdInput || (await onDeposit(Number(amount), type.value));
    if (!txId) {
      this.setState({ transferErrorMessage: ERROR_TRANSACTION });
      return;
    }
    const paramsDeposit = {
      amount: Number(amount),
      type: type.value,
      txId,
      address: address.replace(/\s+/g, ' ').trim().toLowerCase(),
    };
    deposit(paramsDeposit);
    this.setState({ transferErrorMessage: '' });
  };

  closeModal = () => {
    const { toggleModal, resetDepositSubmit } = this.props;
    toggleModal(false);
    setTimeout(function () {
      resetDepositSubmit();
    }, 400);
  };

  onClickConnect = (e) => {
    e.preventDefault();
    this.props.connectWallet('deposit');
  };

  render() {
    const { visibleModal, handleSubmit, kWallet, status } = this.props;
    const { transferErrorMessage } = this.state;
    const { sendingDeposit, depositSuccess, depositError } = kWallet;
    let statusDeposit;
    switch (status) {
      case 1:
        statusDeposit = 'Confirming transfer';
        break;
      case 2:
        statusDeposit = 'Pending Transaction';
        break;
      case 3:
        statusDeposit = 'Confirmed';
        break;

      default:
        statusDeposit = 'Deposit';
        break;
    }
    if (sendingDeposit) statusDeposit = 'Sending Deposit';
    const processing = sendingDeposit || [1, 2].includes(status);

    const msgError = depositError || transferErrorMessage;
    const showTransactionInput = msgError && msgError.trim() !== '' && msgError === ERROR_STALE_TRANSACTION_ID;

    return (
      <Modal className="kambria-modal codebase-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button type="button" className="close-button" onClick={this.closeModal} />
            <div>
              <span className="title d-block text-center mt-4" style={{ color: '#13CDAC', fontSize: '24px' }}>
                Deposit
              </span>
              {depositSuccess ? (
                <div className="content">
                  <p>
                    Your deposit has been sent to the system, when the transaction is successful, an email will notify
                    you.
                  </p>
                  <div style={{ textAlign: 'center' }}>
                    <Button type="primary" onClick={this.closeModal}>
                      OK
                    </Button>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit(this.submitRequest)}>
                  <div className="content">
                    <div style={{ marginTop: 15, marginBottom: 15 }}>
                      <Button type="primary" size="sm" onClick={this.onClickConnect}>
                        Connect to other wallet
                      </Button>
                    </div>
                    <div>
                      <Field
                        name="type"
                        component={SelectField}
                        options={TYPE_DEPOSIT}
                        selectProps={{
                          isMulti: false,
                          placeholder: 'Select type...',
                        }}
                        validate={required}
                      />
                    </div>
                    <br />
                    <div>
                      <Field name="amount" placeholder="Amount" component={TextField} validate={required} />
                    </div>
                    <div>
                      <Field name="address" placeholder="Address" readOnly component={TextField} validate={required} />
                    </div>
                    <br />
                    {showTransactionInput && (
                      <div>
                        <Field
                          name="txIdInput"
                          placeholder="Enter new transaction ID here..."
                          component={TextField}
                          validate={required}
                        />
                      </div>
                    )}
                    <p>Your deposit will be sent to kwallet.</p>
                    {processing && (
                      <p style={{ color: 'orange' }}>
                        Warning: Do not close the browser while processing. You may lose the deposit amount.
                      </p>
                    )}
                    {msgError && <p style={{ color: 'red' }}>{msgError}</p>}
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <LoadingButton loading={processing} type="submit" variant="primary">
                      {statusDeposit}
                    </LoadingButton>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({ kWallet, blockchain }) => {
  return {
    kWallet,
    initialValues: {
      address: blockchain.account,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  depositKWallet: (params) => dispatch(depositKWallet(params)),
  transferKAT,
  transferKYTE,
  resetDepositSubmit: () => dispatch({ type: types.RESET_SUBMIT_REQUEST }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: FORM_NAME,
    asyncBlurFields: [],
    enableReinitialize: true,
  })(DepositModal),
);
